import {Link, Typography} from '@mui/material';

export default function FooterSocial() {
  return (
    <>
      <Typography variant="h6" color="text.primary" gutterBottom>
        Follow Us
      </Typography>
      <Link target="_blank" href="https://www.youtube.com/@CraftySmileOfficial" color="inherit" display="block">
        Youtube
      </Link>
    </>
  );
}
